import { useModal } from "mui-modal-provider";
import { useRouter } from "next/router";
import { Button } from "shared/components/atoms/Button";
import {
  BaseModal,
  BaseModalProps,
} from "shared/components/organisms/modal/BaseModal";
import { Paths } from "utils/routes";

export interface OnlyFirstTimeModalProps extends BaseModalProps {
  name: string;
  onClick: () => void;
}

export const OnlyFirstTimeModal = ({
  onClick,
  name,
  ...baseModalProps
}: OnlyFirstTimeModalProps) => {
  return (
    <BaseModal
      title="申し訳ございません"
      subTitle={`このメニューは${name}先生に初めてお申し込みされる方のみ、ご利用いただける初回限定メニューです。恐れ入りますが他のメニューをご検討ください🙇‍♀️`}
      {...baseModalProps}
    >
      <Button onClick={onClick} tw="w-full bg-gradient-theme-to-l">
        占い師ページに戻る
      </Button>
    </BaseModal>
  );
};

export const useOnlyFirstTimeModal = () => {
  const { showModal, ...modal } = useModal();
  const { push } = useRouter();

  const showOnlyFirstTimeModal = ({
    fortuneTellerId,
    fortuneTellerName,
  }: {
    fortuneTellerId: number;
    fortuneTellerName: string;
  }) => {
    showModal(OnlyFirstTimeModal, {
      name: fortuneTellerName,
      onClick: async () => {
        await push(Paths.fortuneTellers.show(fortuneTellerId));
      },
    });
  };

  return {
    showModal: showOnlyFirstTimeModal,
    ...modal,
  };
};
